const blogListConstantsEn = {
  blogListTitle:'Blogs',
  arabicTitle: 'ARABIC TITLE',
  englishTitle: 'ENGLISH TITLE',
  publishDate: 'PUBLISH DATE',
  blogStatus: 'STATUS',
  totalBlogs: 'Blogs',
  deleteBlogTitle: 'Delete Blog',
  deleteBlogContent: 'Are you sure you want to delete this Blog from the admin panel ?',
};
export default blogListConstantsEn;
